//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Input, Row, Col} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const roadEnum = [
  {value:'PUBLIC', label:'Public'}, 
  {value:'PRIVATE', label:'Private'}, 
  {value:'UNKNOWN', label:'Unknown'}, 
];

const electricalTypeEnum = [
  {value:'PUBLIC', label:'Public'}, 
  {value:'SOLAR', label:'Solar'}, 
  {value:'GENERATOR', label:'Generator'}, 
  {value:'WIND', label:'Wind'}, 
  {value:'HYDRO_ELECTRIC', label:'Hydro Electric'}, 
  {value:'NO_ELECTRICAL_SERVICE', label:'No Electrical Service'}, 
];

const sewerTypeEnum = [
  {value:'PUBLIC', label:'Public'}, 
  {value:'SEPTIC', label:'Septic'}, 
  {value:'CESSPOOL', label:'Cesspool'}, 
  {value:'NONE', label:'None'}, 
];

const waterTypeEnum = [
  {value:'PUBLIC', label:'Public'}, 
  {value:'WELL', label:'Well'}, 
  {value:'CISTERN', label:'Cistern'}, 
  {value:'HAULED_WATER', label:'Hauled Water'}, 
];

const gasTypeEnum = [
  {value:'PUBLIC', label:'Public'}, 
  {value:'PRIVATE', label:'Private'}, 
  {value:'NONE', label:'None'}, 
];

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const Utilities  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getCompressRatio=(size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  const updateFileDescription=(index, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let target = newUPD[field];
    if(target &&  target[index]){
      target[index].description = description;
    }

    newUPD[field] = target;
    props.update(newUPD);
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop=(acceptedFiles, rejectedFiles, field, type='Misc', typeFk=0, description='')=>{

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let target = newUPD[field];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:typeFk, description:description});
                newUPD[field] = target;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const removeFile=(field,index)=>{
    let newUPD = Object.assign({}, props.upd);
    let target = newUPD[field];

    let targetToDelete = target[index];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index, 1);
        newUPD[field] = target;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index, 1);
      newUPD[field] = target;
      props.update(newUPD);
    }

  }

  const getElectricalTypeLabel=(electricalType)=>{
    for(let i=0;i<electricalTypeEnum.length;i++){
      if(electricalTypeEnum[i].value===electricalType)
        return electricalTypeEnum[i].label;
    }

    return electricalType;
  }

  const getSewerTypeLabel=(sewerType)=>{
    for(let i=0;i<sewerTypeEnum.length;i++){
      if(sewerTypeEnum[i].value===sewerType)
        return sewerTypeEnum[i].label;
    }

    return sewerType;
  }

  const getWaterTypeLabel=(waterType)=>{
    for(let i=0;i<waterTypeEnum.length;i++){
      if(waterTypeEnum[i].value===waterType)
        return waterTypeEnum[i].label;
    }

    return waterType;
  }

  const getGasTypeLabel=(gasType)=>{
    for(let i=0;i<gasTypeEnum.length;i++){
      if(gasTypeEnum[i].value===gasType)
        return gasTypeEnum[i].label;
    }

    return gasType;
  }

  const updateRoadDetail=(field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let road = Object.assign({}, newUPD.property.site.offSiteFeature.road);
    road[field] = value;
    
    newUPD.property.site.offSiteFeature.road = road;
    props.update(newUPD);
  }

  const updateElectricalOffgrid=(index, offGrid)=>{
    let newUPD = Object.assign({}, props.upd);
    let electricalServices = newUPD.property.site.siteUtility.electricalServices.slice();
    electricalServices[index].offGridService = offGrid;
    
    newUPD.property.site.siteUtility.electricalServices = electricalServices;
    console.log(newUPD);
    props.update(newUPD);
  }
  
  const updateSewerType=(sewer)=>{
    let newUPD = Object.assign({}, props.upd);
    let sewerServices = newUPD.property.site.siteUtility.sewerServices.slice();

    if(sewer==='NONE'){
      sewerServices = [{sewerType:sewer}];
    }
    else{
      for(let i=0;i<sewerServices.length;i++){
        if(sewerServices[i].sewerType==='NONE'){
          sewerServices = [];
          break;
        }
      }

      sewerServices.push({sewerType:sewer});
    }
    
    newUPD.property.site.siteUtility.sewerServices = sewerServices;
    props.update(newUPD);
  }

  const updateGasType=(gas)=>{
    let newUPD = Object.assign({}, props.upd);
    let gasServices = newUPD.property.site.siteUtility.gasServices.slice();

    if(gas==='NONE'){
      gasServices = [{gasType:gas}];
    }
    else{
      for(let i=0;i<gasServices.length;i++){
        if(gasServices[i].gasType==='NONE'){
          gasServices = [];
          break;
        }
      }

      gasServices.push({gasType:gas});
    }

    newUPD.property.site.siteUtility.gasServices = gasServices;
    props.update(newUPD);
  }

  const updateElectricalType=(electricalType)=>{
    let newUPD = Object.assign({}, props.upd);
    let electricalServices = newUPD.property.site.siteUtility.electricalServices.slice();

    if(electricalType==='NO_ELECTRICAL_SERVICE'){
      electricalServices = [{electricalType:electricalType}];
    }
    else{
      for(let i=0;i<electricalServices.length;i++){
        if(electricalServices[i].electricalType==='NO_ELECTRICAL_SERVICE'){
          electricalServices = [];
          break;
        }
      }

      electricalServices.push({electricalType:electricalType});
    }

    newUPD.property.site.siteUtility.electricalServices = electricalServices;
    props.update(newUPD);
  }

  const updateWaterType=(water)=>{
    let newUPD = Object.assign({}, props.upd);
    let waterServices = newUPD.property.site.siteUtility.waterServices.slice();

    for(let i=0;i<waterServices.length;i++){
      if(waterServices[i].waterType==='NONE'){
        waterServices = [];
        break;
      }
    }

    waterServices.push({waterType:water});
    
    newUPD.property.site.siteUtility.waterServices = waterServices;
    props.update(newUPD);
  }

  const removeWater=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let waterServices = newUPD.property.site.siteUtility.waterServices.slice();
    waterServices.splice(index,1);
    newUPD.property.site.siteUtility.waterServices = waterServices;
    props.update(newUPD);
  }

  const removeGas=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let gasServices = newUPD.property.site.siteUtility.gasServices.slice();
    gasServices.splice(index,1);
    newUPD.property.site.siteUtility.gasServices = gasServices;
    props.update(newUPD);
  }

  const removeSewer=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let sewerServices = newUPD.property.site.siteUtility.sewerServices.slice();
    sewerServices.splice(index,1);
    newUPD.property.site.siteUtility.sewerServices = sewerServices;
    props.update(newUPD);
  }

  const removeElectricalType=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let electricalServices = newUPD.property.site.siteUtility.electricalServices.slice();
    electricalServices.splice(index,1);
    newUPD.property.site.siteUtility.electricalServices = electricalServices;
    props.update(newUPD);
  }


  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }
  
  //render
  return (
    <div>
      <Row>
        <Col sm="6">
          <label>{!props.disabled?<font color="red">*</font>:null}Is the road that is used to access the subject property public or private? {generateTooltip('roadOwnershipType', 'User to identify whether the road used to access the subject property is public or private. The user should select "Unknown" if unable to determine whether the subject\'s access road is public or private. ')}</label>
          <MySelect
            type="select"
            required={!props.disabled}
            disabled={props.disabled}
            style={props.disabled?disabledStyling:{}}
            value={props.upd.property.site.offSiteFeature.road.roadOwnershipType}
            onChange={(v)=>updateRoadDetail('roadOwnershipType', v)}
            options={roadEnum}
          />
        </Col>
        <Col sm="6">
          <label>{!props.disabled?<font color="red">*</font>:null}Is the property accessible year-round?</label>
          <MySelect
            type="select"
            required={!props.disabled}
            disabled={props.disabled}
            style={props.disabled?disabledStyling:{}}
            value={props.upd.property.site.offSiteFeature.road.yearRoundAccessIndicator}
            onChange={(v)=>updateRoadDetail('yearRoundAccessIndicator', v)}
            options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
          />
        </Col>
      </Row>
      <br/>
      {props.upd.property.site.offSiteFeature.road.roadOwnershipType && props.upd.property.site.offSiteFeature.road.roadOwnershipType!=='PUBLIC' && props.upd.property.site.offSiteFeature.road.roadOwnershipType!==''?<div>
        <label>{!props.disabled?<font color="red">*</font>:null}Is the road used to access the subject property adequately maintained? {generateTooltip('roadOwnershipType', 'User to indicate whether the subject\'s access road is adequately maintained.')}</label>
        <MySelect
          type="select"
          required={!props.disabled}
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={props.upd.property.site.offSiteFeature.road.roadMaintainedIndicator}
          onChange={(v)=>updateRoadDetail('roadMaintainedIndicator', v)}
          options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
        />
        <br/>
      </div>:null}

      <label>{!props.disabled && props.upd.property.site.offSiteFeature.road.roadOwnershipType!=='PUBLIC' && props.upd.property.site.offSiteFeature.road.roadMaintainedIndicator==='False'?<font color="red">*</font>:null}Image(s) of road damage {generateTooltip('imageRoad', 'Image(s) evidencing the lack of road maintenance (e.g. potholes, wash-outs, etc.) Note: This image should only be populated in cases where the road is privately maintained or if the property data collector does not know who maintains the road. ')}</label>
      <br/>
      <input
        tabIndex={-1}
        autoComplete="off"
        style={{ opacity: 0, height: 0, width:0 }}
        value={props.upd.imageRoad&&props.upd.imageRoad.length>0?" ":""}
        required={!props.disabled && props.upd.property.site.offSiteFeature.road.roadOwnershipType!=='PUBLIC' && props.upd.property.site.offSiteFeature.road.roadMaintainedIndicator==='False'}
      />
      <div>
        <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, 'imageRoad', 'ROAD_UNDER_MAINTAINED', 0)}} className="my-dropzone">
        {
          ({getRootProps, getInputProps}) => (
            <div
              {...getRootProps({
                className: 'my-dropzone',
              })}
            >
              <input {...getInputProps()} />
              <center>Choose files to upload</center>
            </div>
          )
        }
        </Dropzone>
        {
          !props.upd.imageRoad?null:props.upd.imageRoad.map(
            (photo, index)=>{
              return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                <div>
                  <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageRoad',index)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                </div>
                <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, 'imageRoad', e.target.value)}/>
                <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
              </div>
            }
          )
        }
      </div>
      <br/>
      <div className="my-divider"/>
      <label>{!props.disabled?<font color="red">*</font>:null}Indicate the electrical service type(s) for the subject property. If more than one type is available, select all that apply. {generateTooltip('electricalType', 'User to select the best option(s) to describe the type of electrical service active on the subject property. User should add one observation per electrical service type. If no electrical service is active, then the user should select the \'No Electrical Service\' option.')}</label>
      <MySelect
        type="select"
        required={!props.disabled}
        disabled={props.disabled}
        style={props.disabled?disabledStyling:{}}
        value={props.upd.property.site.siteUtility.electricalServices && props.upd.property.site.siteUtility.electricalServices.length>0?" ":""}
        onChange={(v)=>updateElectricalType(v)}
        options={electricalTypeEnum}
      />
      {
        props.upd.property.site.siteUtility.electricalServices.map(
          (electricalService, index)=>{
            return <span className="my-badge3" key={index} style={{marginRight:'5px', padding:'10px'}}>
                <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeElectricalType(index)}/> {getElectricalTypeLabel(electricalService.electricalType)}
              </span>
          })
      }
      {
        props.upd.property.site.siteUtility.electricalServices.map(
          (electricalService, index)=>{
            if(electricalService.electricalType!=='PUBLIC' && electricalService.electricalType!=='NO_ELECTRICAL_SERVICE'){
              return <Card key={index} style={{marginTop:'10px'}}>
                <CardHeader>{getElectricalTypeLabel(electricalService.electricalType)}</CardHeader>
                <CardBody>
                  <label>{!props.disabled?<font color="red">*</font>:null}Is this alternative electrical service also connected to the grid?</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={electricalService.offGridService}
                    onChange={(v)=>updateElectricalOffgrid(index, v)}
                    options={[{label:"True", value:"True"}, {label:"False", value:"False"}]}
                  />
                </CardBody>
              </Card>
            }
            return null;
          })
      }
      <br/>
      <label>{!props.disabled?<font color="red">*</font>:null}Indicate the type(s) of sewage disposal available for the subject property. If more than one type is available, select all that apply. {generateTooltip('sewerType', 'User to select the best option(s) to describe the type of sewage disposal active on the subject property. User should add one observation per sewage disposal type. If no sewage service is active, then the user should select the "None" option.')}</label>
      <MySelect
        type="select"
        required={!props.disabled}
        disabled={props.disabled}
        style={props.disabled?disabledStyling:{}}
        value={props.upd.property.site.siteUtility.sewerServices && props.upd.property.site.siteUtility.sewerServices.length>0?" ":""}
        onChange={(v)=>updateSewerType(v)}
        options={sewerTypeEnum}
      />
      {
        props.upd.property.site.siteUtility.sewerServices.map(
          (sewerService, index)=>{
            return <span className="my-badge3" key={index} style={{marginRight:'5px', padding:'10px'}}>
                <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeSewer(index)}/> {getSewerTypeLabel(sewerService.sewerType)}
              </span>
          })
      } 
      <br/>
      <label>{!props.disabled?<font color="red">*</font>:null}Indicate the type(s) of water source available for subject property. If more than one type is available, select all that apply. {generateTooltip('waterType', 'User to select the best option(s) to describe the type of water source active on the subject property. User should add one observation per water source type.')}</label>
      <MySelect
        type="select"
        required={!props.disabled}
        disabled={props.disabled}
        style={props.disabled?disabledStyling:{}}
        value={props.upd.property.site.siteUtility.waterServices && props.upd.property.site.siteUtility.waterServices.length>0?" ":""}
        onChange={(v)=>updateWaterType(v)}
        options={waterTypeEnum}
      />
      {
        props.upd.property.site.siteUtility.waterServices.map(
          (waterService, index)=>{
            return <span className="my-badge3" key={index} style={{marginRight:'5px', padding:'10px'}}>
                <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeWater(index)}/> {getWaterTypeLabel(waterService.waterType)}
              </span>
          })
      }
      <br/>
      <label>{!props.disabled?<font color="red">*</font>:null}What type(s) of gas service does the subject have? {generateTooltip('gasType', 'User to select the best option(s) to describe the type of gas service active on the subject property. User should add one observation per gas service type.')}</label>
      <MySelect
        type="select"
        required={!props.disabled}
        disabled={props.disabled}
        style={props.disabled?disabledStyling:{}}
        value={props.upd.property.site.siteUtility.gasServices && props.upd.property.site.siteUtility.gasServices.length>0?" ":""}
        onChange={(v)=>updateGasType(v)}
        options={gasTypeEnum}
      />
      {
        props.upd.property.site.siteUtility.gasServices.map(
          (gasService, index)=>{
            return <span className="my-badge3" key={index} style={{marginRight:'5px', padding:'10px'}}>
                <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeGas(index)}/> {getGasTypeLabel(gasService.gasType)}
              </span>
          })
      }
    </div>
  )
}


export default Utilities;